import UserImpersonation from './UserImpersonation';
import UserImpersonationContainer from './UserImpersonationContainer';

export default UserImpersonationContainer;
export { UserImpersonation };
